import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Sort(props) {
    return (
        <SvgIcon {...props}>
            <g>
                <polygon points="12,9.612 10.693,8.24 7.818,11.257 4.944,8.24 3.637,9.612 7.818,14 9.127,12.628 9.127,12.628" />
                <polygon points="8.364,5.389 4.182,1 2.874,2.373 2.874,2.373 0,5.389 1.308,6.76 4.182,3.743 7.059,6.76" />
            </g>
        </SvgIcon>
    );
}

Sort.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Sort;
